import ReactPlayer, { ReactPlayerProps } from "react-player"
import { VideoEvent } from "../../client"
import { VideoThumbnail } from "../VideoThumbnail/VideoThumbnail"
import { Box } from "@mantine/core"

interface WrappedPlayerProps {
  video: VideoEvent
  reactPlayerProps: ReactPlayerProps
  inView?: boolean
}

const WrappedPlayer: React.FC<WrappedPlayerProps> = ({ video, reactPlayerProps, inView = true }) => {
  return (
    <Box style={{ position: "relative", width: "100%", aspectRatio: "16 / 9", borderRadius: 20, overflow: "hidden" }}>
      <VideoThumbnail video={video} inView={inView} radius={20} />
      {reactPlayerProps.playing && (
        <Box
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 2,
            borderRadius: 20,
            overflow: "hidden",
          }}
        >
          <ReactPlayer
            url={video.url}
            width="100%"
            height="100%"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
            }}
            {...reactPlayerProps}
            config={{
              file: {
                attributes: {
                  referrerPolicy: "strict-origin-when-cross-origin",
                  playsInline: true,
                },
              },
              ...reactPlayerProps.config,
            }}
          />
        </Box>
      )}
    </Box>
  )
}

export default WrappedPlayer